export default "__VITE_ASSET__B$WJyRN2__"